import YourPharmacyPage from "./YourPharmacyPage";

export default YourPharmacyPage;

export * from "./YourPharmacyPage";
